export default class CustomBlockParser {
    constructor() {
        this.regexpToHtmlMap = {
            'switchStart': {
                'regex': /(\[Switch ?(\[CustomField:.*?\])?(.*?)\])/g,
                'replace': (match, p1, p2, p3, offset, string) => {
                    return '<rm-block-switch data-value="' + (p2 ? p2 : p3) + '">';
                }
            },
            'switchEnd': {
                'regex': /(\[EndSwitch\])/g,
                'replace': '</rm-block-switch>'
            },
            'caseStart': {
                'regex': /(\[Case (.*?)\])/g,
                'replace': (match, p1, p2) => {
                    p2 = p2.replace(/['"]+/g, '');
                    return '<rm-block-switch-case data-value="' + p2 + '">'
                }
            },
            'caseEnd': {
                'regex': /(\[EndCase\])/g,
                'replace': '</rm-block-switch-case>'
            },
            'defaultStart': {
                'regex': /(\[Default\])/g,
                'replace': '<rm-block-switch-default>'
            },
            'defaultEnd': {
                'regex': /(\[EndDefault\])/g,
                'replace': '</rm-block-switch-default>'
            }
        };
        this.regexpToCodeMap = {
            'switchStart': {
                'regex': /(<rm-block-switch(.*?)data-value="(.*?)"(.*?)>(<rm-block-toolbar[\s\S]*?<\/rm-block-toolbar>))/g,
                'replace': '[Switch $3]'
            },
            'switchEnd': {
                'regex': /(<\/rm-block-switch>)/g,
                'replace': '[EndSwitch]'
            },
            'caseStart': {
                'regex': /(<rm-block-switch-case(.*?)data-value="(.*?)"(.*?)>)/g,
                'replace': (match, p1, p2, p3) => {
                    let matchNumber = p3.match(/[\d.]+/);
                    if(!matchNumber || p3 !== matchNumber[0]) {
                        p3 = '"' + p3 + '"';
                    }
                    return '[Case ' + p3 + ']';
                }
            },
            'caseEnd': {
                'regex': /(<\/rm-block-switch-case>)/g,
                'replace': '[EndCase]'
            },
            'defaultStart': {
                'regex': /(<rm-block-switch-default(.*?)>)/g,
                'replace': '[Default]'
            },
            'defaultEnd': {
                'regex': /(<\/rm-block-switch-default>)/g,
                'replace': '[EndDefault]'
            },
            'transcludeStart': {
                'regex': /<ng-transclude>/g,
                'replace': ''
            },
            'transcludeEnd': {
                'regex': /<\/ng-transclude>/g,
                'replace': ''
            }
        }
    }


    parseToHtml(content) {
        return this.parse(content, this.regexpToHtmlMap, true);
    };

    parseToCode(content) {
        return this.parse(content, this.regexpToCodeMap, false);
    };

    parse(content, regexpMap) {
        angular.forEach(regexpMap, (item) => {
            content = content.replace(item.regex, item.replace);
        });
        return content;
    }
};
